import { useMediaQuery } from "react-responsive";

import {
  shouldShowConsentAndPaySubscriptionBillingDisclaimer,
  shouldShowSidebarSubscriptionBillingDisclaimer,
} from "@jti/commerce/shared";
import { BREAKPOINT_LARGE } from "@jti/fe-common";

import { getFilteredSubscriptionItems } from "@checkout-v2/features/SubscriptionSummary/utils/getFilteredSubscriptionItems";

import { useCheckoutV2Configuration } from "../../providers/CheckoutV2ConfigurationProvider/hooks/useCheckoutV2Configuration";
import { useCartItems } from "../useCartItems";

export const useCheckoutSubscriptionDisplayState = () => {
  const isDesktopView = useMediaQuery({ minWidth: BREAKPOINT_LARGE });
  const checkoutConfiguration = useCheckoutV2Configuration();
  const { data: cartItems, isLoading, error } = useCartItems();

  const subscriptionItems = getFilteredSubscriptionItems(cartItems);
  const showSubscriptionSummary = !isLoading && !error && subscriptionItems.length > 0;

  return {
    subscriptionItems,
    showSubscriptionSummary,
    showSidebarBillingDisclaimer:
      showSubscriptionSummary &&
      shouldShowSidebarSubscriptionBillingDisclaimer(checkoutConfiguration.subscriptionTermsPlacement, isDesktopView),
    showConsentAndPaySubscriptionBillingDisclaimer:
      showSubscriptionSummary &&
      shouldShowConsentAndPaySubscriptionBillingDisclaimer(
        checkoutConfiguration.subscriptionTermsPlacement,
        isDesktopView
      ),
  };
};
